/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export function dateTimePicker(element) {
  if (typeof flatpickr === 'function') {
    var type = element.dataset.type ? element.dataset.type : 'date';
    var format = element.dataset.format ? element.dataset.format : 'm/d/Y';
    var minDate = element.dataset.minDate ? element.dataset.minDate : null;
    var minTime = element.dataset.minTime ? element.dataset.minTime : '00:00';
    var maxTime = element.dataset.maxTime ? element.dataset.maxTime : '23:59';
    var config = {
      dateFormat: format,
      minDate: minDate
    };
    if (type === 'datetime') {
      config.enableTime = true;
    }
    if (type === 'time') {
      config.enableTime = true;
      config.noCalendar = true;
      config.minTime = minTime;
      config.maxTime = maxTime;
    }
    // console.warn(config);
    flatpickr(element, config);
  }
}
export function datetimePickerInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var datePickerElements = container.querySelectorAll(".date-picker");
  for (var i = 0; i < datePickerElements.length; i++) {
    dateTimePicker(datePickerElements[i]);
  }
  // fix for month select inside modal
  document.addEventListener('focusin', function (e) {
    if (e.target.closest(".flatpickr-calendar") !== null) {
      e.stopImmediatePropagation();
    }
  });
}